import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { LocationTypeEnum } from "@perxis-auto/shared/lib";
import { Message } from "@perxis-auto/ui-kit";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import { selectGeo } from "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import styles from "./GeoLocationDetector.module.scss.js";
const GeoLocationDetector = withEnabledComponent(
  memo(function GeoLocationDetector2({ isVisible, location, t, onSuccess, onClose }) {
    return /* @__PURE__ */ jsx(Message, { className: styles.geoLocationDetector, open: isVisible, onSuccess, onClose, children: t(`widgets.geoLocationDetector.${(location == null ? void 0 : location.type) ?? LocationTypeEnum.City}`, { location: location == null ? void 0 : location.name }) });
  }),
  selectGeo
);
export {
  GeoLocationDetector
};
